module.exports = __webpack_public_path__ + "media/chaoeBG.41761df8.mp3";